import { useLayoutEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { DEFAULT_TITLE } from "./lib/usePageTitle";
import { Ticker } from "./components/Ticker";
import { Nav } from "./components/Nav";
import Home from "./pages/Home";
import Country from "./pages/Country";
import Forecast from "./pages/Forecast";
import Leaderboard from "./pages/Leaderboard";
import Race from "./pages/Race";
import Candidacy from "./pages/Candidacy";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import World from "./pages/World";
import Polls from "./pages/Polls";
import PollDetail from "./pages/PollDetail";
import Candidates from "./pages/Candidates";
import HowItWorks from "./pages/HowItWorks";
import MuBoard from "./pages/MuBoard";

export default function App() {
  // The server rewrites <title> per entity on full loads only; without this
  // reset, SPA navigations keep the previous page's title (e.g. /polls showing
  // a poll's title). Pages with entity data re-set theirs via usePageTitle —
  // layout effect here so the reset always flushes before their passive set.
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    document.title = DEFAULT_TITLE;
  }, [pathname]);

  // The unit board is opened from a link pasted in a unit's channel, usually on
  // a phone mid-fight. The forecast app's ticker and navigation are noise
  // there, and on a small screen they cost the board a third of the viewport.
  const bare = pathname.startsWith("/mu/");

  return (
    <>
      {bare ? null : (
        <>
          <Ticker />
          <Nav />
        </>
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/c/:countryId" element={<Country />} />
        <Route path="/c/:countryId/e/:electionId" element={<Forecast />} />
        <Route path="/c/:countryId/race/:office" element={<Race />} />
        {/* Legacy deep URL — still loads, then redirects to the canonical /u/:username. */}
        <Route path="/c/:countryId/race/:office/:candidacyId" element={<Candidacy />} />
        <Route path="/world" element={<World />} />
        <Route path="/polls" element={<Polls />} />
        <Route path="/polls/:id" element={<PollDetail />} />
        <Route path="/candidates" element={<Candidates />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/u/:username" element={<Profile />} />
        <Route path="/u/:username/c/:candidacyId" element={<Candidacy />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/admin" element={<Admin />} />
        {/* The unit board, opened from a share link the unit pastes in its channel. */}
        <Route path="/mu/:token" element={<MuBoard />} />
      </Routes>
    </>
  );
}
